// Thin client for the tower-api player-state endpoints.
import { config } from "../config";
import type { PlayerState } from "./playerState";

export async function fetchRemoteState(
  idToken: string,
): Promise<{ state: PlayerState | null; updatedAt: number | null }> {
  const res = await fetch(`${config.apiUrl}/v1/state`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) throw new Error(`state fetch failed: ${res.status}`);
  return (await res.json()) as { state: PlayerState | null; updatedAt: number | null };
}

export async function putRemoteState(idToken: string, state: PlayerState): Promise<void> {
  const res = await fetch(`${config.apiUrl}/v1/state`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${idToken}`, "Content-Type": "application/json" },
    body: JSON.stringify({ state }),
  });
  if (!res.ok) throw new Error(`state save failed: ${res.status}`);
}
